<template>
  <span>
    <my-navbar></my-navbar>    
    <banner :nombreServicio="nombreServicio"></banner>
    <div class="container"> 
        <el-row :gutter="20" id="coaching">
            <el-col :xs="24" ><h1 style="font-size: 35px !important" class="chevere-title">Outsourcing</h1></el-col>
            <br>
            <el-col :xs="24" :md="12">
                <p class="chevere-text-j">Nuestro conocimientos y herramientas a tu disposición 24/7, libérate de preocupaciones y reduce gastos de operación en tu empresa que nosotros nos hacemos cargo de toda tu plataforma tecnológica, desde los teclados, monitores y ratones que utilizas para trabajar hasta los servidores, computadoras, redes y seguridad que necesita tu empresa para funcionar al 100% estará bajo nuestra protección y supervisión.</p>
            </el-col>
            <el-col class="hidden-md-and-up" :xs="24"><img class="isotipo" src="@/../public/assets/images/services/outsourcing.jpg" alt="Outsourcing" title="Outsourcing"></el-col>

            <el-col class="hidden-sm-and-down" :md="12"><img class="isotipo" src="@/../public/assets/images/services/outsourcing.jpg" alt="Outsourcing" title="Outsourcing"></el-col>
        </el-row>
    
    <tecnologias></tecnologias> 
    <contacto></contacto>
    </div>
        <whatsapp></whatsapp>

    <my-footer></my-footer>
  </span>
</template>

<script>
import Whatsapp from '@/sections/Whatsapp.vue';

import Banner from '@/sections/Banner.vue';
import MyNavbar from '@/sections/Navbar.vue';
import MyFooter from '@/sections/Footer.vue';
import Contacto from '@/sections/Contactanos.vue';
import Tecnologias from '@/sections/Tecnologias.vue';
export default {
    name: "Outsourcing",
  data () {
    return {
      nombreServicio:"Outsourcing"
    }
  },
  components: {    
    Banner,
    Whatsapp,

    Contacto,
    Tecnologias,
    MyNavbar,
    MyFooter
  }
}
</script>

<style>
  .container{
    width: 90%;
    margin: auto;
  }
</style>


// WEBPACK FOOTER //
// src/pages/services/Outsourcing.vue